var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 511,
    height: 380,
    viewBox: "0 0 511 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511 57.2008C511 72.3008 505 86.9008 494.3 97.6008L228.8 363.101C206.5 385.401 170.3 385.401 148 363.101L15.7 230.901C-5.99998 208.001 -5.09998 171.901 17.8 150.201C39.9 129.201 74.5 129.301 96.5 150.201L188.4 242.101L413.5 16.9008C435.8 -5.39922 472 -5.39922 494.3 16.9008C505 27.6008 511 42.1008 511 57.2008Z",
    fill: "url(#paint0_linear_1622_4283)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1622_4283",
    x1: 148.48,
    y1: 17.3408,
    x2: 361.51,
    y2: 230.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62E8A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13CE63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.a6c526b7a298f6c08343b98c9ccc4c41.svg";
export { ForwardRef as ReactComponent };